/*! For license information please see qrevol_main.js.LICENSE.txt */ ! function() {
    var e = {
            "./src/js/main.js": function(e, s, i) {
                "use strict";
                i("jquery"), i("./node_modules/split-type/dist/index.js");
                var t = i("./src/widgets/debug.js"),
                    n = i("jquery");
                (0, t.debugfunction)();
                var c = document.documentElement.clientHeight || window.innerHeight,
                    o = (document.documentElement.clientWidth || window.innerWidth) < 750,
                    a = n(window).scrollTop();

                function r() {
                    return n("#play-video-text").width() / n("#play-video-line-box").width() * 100
                }
                n(window).on("scroll", (function(e) {
                    var s = n(window).scrollTop();
                    s > a ? "down" : "up", a = s, n(n.CN(".product-container .section")).each((function(e, s) {
                        var i = n(s).data("section");
                        1 === i || 2 === i || 9 === i && function(e) {
                            var s = e.getBoundingClientRect(),
                                i = s.top;
                            s.right, s.bottom, s.left;
                            i < c / 2 ? (n(n.CN(".section-ninth .gradient-box")).addClass(n.CN("breathing-light-ani")), n(n.CN(".section-ninth .icon1")).addClass(n.CN("icon1-ani")), n(n.CN(".section-ninth .icon2")).addClass(n.CN("icon2-ani")), n(n.CN(".section-ninth .icon3")).addClass(n.CN("icon3-ani")), n(n.CN(".section-ninth .icon4")).addClass(n.CN("icon4-ani")), n(n.CN(".section-ninth .icon5")).addClass(n.CN("icon5-ani"))) : (n(n.CN(".section-ninth .gradient-box")).removeClass(n.CN("breathing-light-ani")), n(n.CN(".section-ninth .icon1")).removeClass(n.CN("icon1-ani")), n(n.CN(".section-ninth .icon2")).removeClass(n.CN("icon2-ani")), n(n.CN(".section-ninth .icon3")).removeClass(n.CN("icon3-ani")), n(n.CN(".section-ninth .icon4")).removeClass(n.CN("icon4-ani")), n(n.CN(".section-ninth .icon5")).removeClass(n.CN("icon5-ani")))
                        }(s)
                    }))
                })), n(window).on("resize", (function(e) {})), n((function() {
                    n(n.CN(".fadein-up")).each((function() {
                        gsap.set(n(this), {
                            opacity: 0,
                            y: 60
                        }), gsap.fromTo(n(this), {
                            y: 60,
                            opacity: 0
                        }, {
                            y: 0,
                            opacity: 1,
                            duration: .5,
                            ease: "power2.easeOut",
                            immediateRender: !0,
                            scrollTrigger: {
                                trigger: n(this),
                                start: "top-=".concat(o ? "60px" : "0", " bottom-=") + "15%",
                                end: "top-=".concat(o ? "60px" : "0", " bottom-=") + "15%",
                                invalidateOnRefresh: !0,
                                toggleActions: "play none reverse none"
                            },
                            delay: Number(n(this).attr("delay")) || 0
                        })
                    })), n(n.CN(".container-fadein-up-list")).each((function() {
                        var e = n(this).attr("start") || "30%",
                            s = gsap.timeline({
                                scrollTrigger: {
                                    trigger: n(this),
                                    start: "top bottom-=" + (o ? "15%" : e),
                                    end: "top+=50px bottom-=" + (o ? "15%" : "10%"),
                                    invalidateOnRefresh: !0,
                                    toggleActions: "play none reverse none"
                                },
                                onComplete: function() {
                                    ScrollTrigger.refresh()
                                }
                            });
                        n(this).find(n.CN(".fadein-up-list")).each((function(e, i) {
                            gsap.set(n(i), {
                                opacity: 0,
                                y: 100
                            }), s.fromTo(n(i), {
                                y: 100,
                                opacity: 0
                            }, {
                                y: 0,
                                opacity: 1,
                                duration: .5,
                                ease: "power0.easeOut",
                                immediateRender: !0
                            }, "<40%")
                        }))
                    })), setTimeout((function() {
                        n(n.CN(".offset-view")).each((function() {
                            var e = gsap.timeline();
                            e.add(gsap.fromTo(n(this).find("img"), {
                                scale: 1.1,
                                y: "-4.9%"
                            }, {
                                scale: 1.1,
                                y: "4.9%",
                                ease: "sine.inOut",
                                immediateRender: !0,
                                duration: 1
                            })), ScrollTrigger.create({
                                animation: e,
                                trigger: this,
                                start: "top bottom-=0%",
                                end: "bottom top+=0%",
                                invalidateOnRefresh: !0,
                                scrub: 1
                            })
                        }))
                    }), 100), gsap.fromTo(n(n.CN(".section-first .text-area")), {
                        y: 60,
                        opacity: 0
                    }, {
                        y: 0,
                        opacity: 1,
                        duration: .5,
                        ease: "power2.easeOut"
                    }), n(n.CN(".section-third .section-wrap")).on({
                        mouseenter: function() {
                            gsap.to(n.CN(".section-third .line-box .line-left"), 1, {
                                width: "80%",
                                ease: "power3.out"
                            })
                        },
                        mouseleave: function() {
                            gsap.to(n.CN(".section-third .line-box .line-left"), 1, {
                                width: r() + "%",
                                ease: "power3.out"
                            })
                        }
                    }), ScrollTrigger.create({
                        trigger: n.CN(".section-sixth .number"),
                        start: "top bottom-=35%",
                        end: "top+=" + (o ? 100 : 200) + " bottom-=35%",
                        onEnter: function() {
                            gsap.to({
                                progress: 0
                            }, {
                                progress: 1,
                                duration: 2,
                                ease: "power3.out",
                                onUpdate: function() {
                                    var e = "",
                                        s = Math.round(1e4 * this.targets()[0].progress);
                                    e = ",", s = s.toString().replace(/\B(?=(\d{3})+(?!\d))/g, e), n(n.CN(".section-sixth .number")).text(s)
                                }
                            })
                        },
                        scrub: .3,
                        invalidateOnRefresh: !0,
                        id: "s6"
                    }), ScrollTrigger.create({
                        animation: gsap.timeline().add(gsap.fromTo(n.CN(".section-twenty-first .image-gray"), 1, {
                            width: 0
                        }, {
                            width: "100%"
                        })),
                        trigger: n.CN(".section-twenty-first .image-gray"),
                        start: o ? "top top+=80%" : "top center",
                        end: o ? "top toptop-=180%" : "top top-=180%",
                        scrub: !0,
                        invalidateOnRefresh: !0,
                        id: "s21",
                        onEnter: function() {
                            n(n.CN(".section-twenty-first .image-gray-box .line")).css({
                                display: "block"
                            })
                        },
                        onLeave: function() {
                            n(n.CN(".section-twenty-first .image-gray-box .line")).css({
                                display: "none"
                            })
                        },
                        onEnterBack: function() {
                            n(n.CN(".section-twenty-first .image-gray-box .line")).css({
                                display: "block"
                            })
                        },
                        onLeaveBack: function() {
                            n(n.CN(".section-twenty-first .image-gray-box .line")).css({
                                display: "none"
                            })
                        }
                    })
                })), window.onload = function() {
                    n("#play-video-line").css("width", r() + "%")
                }
            },
            "./src/widgets/AlbumCart/index.js": function(e, s, i) {
                "use strict";

                function t() {
                    document.documentElement.clientWidth || window.innerWidth;
                    var e = new Swiper("#albumSwiper", {
                        loop: !0,
                        effect: "cards",
                        grabCursor: !0
                    });
                    // document.querySelector("#albumSwiper").addEventListener("click", (function() {
                    //     e.slideNext()
                    // }))
                }
                i.d(s, {
                    default: function() {
                        return t
                    }
                })
            },
            "./src/widgets/Album/index.js": function(e, s, i) {
                "use strict";

                function t() {
                    document.documentElement.clientWidth || window.innerWidth;
                    new Swiper("#qSwiperalbum", {
                        grabCursor: !0,
                        speed: 2e4,
                        loop: !0,
                        slidesPerView: "auto",
                        a11y: {
                            slideRole: "listitem"
                        },
                        autoplay: {
                            pauseOnMouseEnter: !0,
                            disableOnInteraction: !1,
                            delay: 0
                        }
                    }), new Swiper("#qSwiperalbum-1", {
                        grabCursor: !0,
                        speed: 16e3,
                        loop: !0,
                        slidesPerView: "auto",
                        a11y: {
                            slideRole: "listitem"
                        },
                        autoplay: {
                            pauseOnMouseEnter: !0,
                            disableOnInteraction: !1,
                            delay: 0
                        }
                    })
                }
                i.d(s, {
                    default: function() {
                        return t
                    }
                })
            },
            "./src/widgets/ClassExtension.js": function(e, s, i) {
                ! function(e) {
                    e.extend({
                        CN: function(e) {
                            return e.startsWith(".") ? e.split(" ").map((function(e) {
                                return e.startsWith(".") ? ".".concat("qrevol_").concat(e.slice(1)) : e
                            })).join(" ") : "qrevol_" + e
                        }
                    })
                }(i("jquery"))
            },
            "./src/widgets/ContrastContainer/index.js": function(e, s, i) {
                "use strict";
                var t = i("jquery");

                function n(e, s) {
                    return function(e) {
                        if (Array.isArray(e)) return e
                    }(e) || function(e, s) {
                        var i = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                        if (null != i) {
                            var t, n, c, o, a = [],
                                r = !0,
                                g = !1;
                            try {
                                if (c = (i = i.call(e)).next, 0 === s) {
                                    if (Object(i) !== i) return;
                                    r = !1
                                } else
                                    for (; !(r = (t = c.call(i)).done) && (a.push(t.value), a.length !== s); r = !0);
                            } catch (e) {
                                g = !0, n = e
                            } finally {
                                try {
                                    if (!r && null != i.return && (o = i.return(), Object(o) !== o)) return
                                } finally {
                                    if (g) throw n
                                }
                            }
                            return a
                        }
                    }(e, s) || function(e, s) {
                        if (!e) return;
                        if ("string" == typeof e) return c(e, s);
                        var i = Object.prototype.toString.call(e).slice(8, -1);
                        "Object" === i && e.constructor && (i = e.constructor.name);
                        if ("Map" === i || "Set" === i) return Array.from(e);
                        if ("Arguments" === i || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(i)) return c(e, s)
                    }(e, s) || function() {
                        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
                    }()
                }

                function c(e, s) {
                    (null == s || s > e.length) && (s = e.length);
                    for (var i = 0, t = new Array(s); i < s; i++) t[i] = e[i];
                    return t
                }
                t((function() {
                    var e = document.documentElement.clientWidth || window.innerWidth;
                    ! function() {
                        if (document.getElementById("compare_data")) {
                            var s, i = JSON.parse(document.getElementById("compare_data").text),
                                c = (s = i, JSON.parse(JSON.stringify(s)));
                            o(i), t(t.CN(".contrast-container")).on("click", t.CN(".h4"), (function() {
                                var e = this;
                                t(t.CN(".contrast-container .h4")).each((function(s, i) {
                                    i !== e && t(i).children(t.CN(".popup")).hide()
                                })), t(this).children(t.CN(".popup")).toggle()
                            })), t(document).on("click", (function(e) {
                                t(e.target).closest(t.CN(".contrast-container .h4")).length || t(t.CN(".contrast-container .popup")).hide()
                            })), t(t.CN(".contrast-container")).on("click", t.CN(".h4 .modlist"), (function(e) {
                                var s = t(this).attr("productname"),
                                    n = t(this).attr("parentlevel");
                                c[n] = i[s], o(c)
                            }))
                        }

                        function o(s) {
                            var c = "";
                            Object.entries(s).forEach((function(s, t) {
                                var o = n(s, 2),
                                    a = o[0],
                                    r = o[1];
                                t > (e > 750 ? 2 : 1) || (c += '<div class="'.concat("qrevol_", 'item">\n          <img src="').concat(r.imgsrc, '" alt="').concat(r.name, '">\n          <div class="').concat("qrevol_", 'h4">').concat(r.name, '\n            <svg width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">\n              <path d="M1.5 1L6.5 6L11.5 1" stroke="#DB2D30" stroke-width="2" stroke-linecap="round"/>\n            </svg>\n            <div class="').concat("qrevol_", 'popup">\n              <div class="').concat("qrevol_", 'models">').concat(r.choose, "</div>"), Object.entries(i).forEach((function(e) {
                                    var s = n(e, 2),
                                        i = s[0],
                                        t = s[1];
                                    c += '<p class="'.concat("qrevol_", 'modlist" parentlevel="').concat(a, '" productname="').concat(i, '">\n                <svg class="').concat(r.name == t.name ? "".concat("qrevol_", "active") : "", '" width="11" height="8" viewBox="0 0 11 8" fill="none" xmlns="http://www.w3.org/2000/svg">\n                  <path d="M1.33346 3L4.33354 6L10.0002 1" stroke="black" stroke-width="1.5" stroke-linecap="round"/>\n                </svg><span>').concat(t.name, "</span></p>")
                                })), c += "</div>\n          </div>\n          <div>", r.open_purchase ? c += '<button class="'.concat("qrevol_", 'buy-now purchase-sales-channel-btn" product-name="').concat(r.name.replaceAll(" ", "-").replaceAll("Roborock-", ""), '" data-toggle="modal" data-target="#product-sales-channel">').concat(r.btntext, "</button>") : r.show_link_btn ? c += '<a href="'.concat(r.btn_link, '"><button class="').concat("qrevol_", 'buy-now">').concat(r.btntext, "</button></a>") : c += '<div class="'.concat("qrevol_", 'no_btn"></div>'), c += "</div>\n          <ul>", Object.entries(r).forEach((function(e) {
                                    var s = n(e, 2),
                                        i = s[0],
                                        t = s[1];
                                    i.includes("item") && (c += "<li>".concat(t, "</li>"))
                                })), c += "</ul>\n        </div>")
                            })), t("#compare-table").html(c), "function" == typeof ReloadSalesChannelEvents && ReloadSalesChannelEvents()
                        }
                    }()
                }))
            },
            "./src/widgets/FullScreenVideo/index.js": function(e, s, i) {
                "use strict";
                var t = i("jquery");
                t((function() {
                    function e() {
                        t(t.CN(".full_screen_video")).hide();
                        var e = new window.CustomEvent("hide.all.modals");
                        document.dispatchEvent(e)
                    }! function() {
                        var e = document.querySelectorAll(t.CN(".as-youtube-video"));
                        if (e.length > 0) {
                            var s = document.createElement("script");
                            s.src = "https://www.youtube.com/iframe_api";
                            var i = document.getElementsByTagName("script")[0];
                            i.parentNode.insertBefore(s, i);
                            var n = [],
                                c = function(e) {
                                    document.addEventListener("hide.all.modals", (function(e) {
                                        for (var s = 0; s < n.length; s++) n[s].pauseVideo()
                                    }))
                                };
                            window.onYouTubeIframeAPIReady = function() {
                                for (var s = 0; s < e.length; s++) n.push(new window.YT.Player(e[s], {
                                    events: {
                                        onReady: c
                                    }
                                }))
                            }
                        }
                    }(), t(t.CN(".section-second .video-box")).on("click", (function(e) {
                        t(t.CN(".full_screen_video")).show()
                    })), t(t.CN(".full_screen_video")).on("click", (function(s) {
                        e()
                    })), t(t.CN(".full_screen_video .video-close")).on("click", (function(s) {
                        e()
                    }))
                }))
            },
            "./src/widgets/LeftNav/index.js": function(e, s, i) {
                "use strict";
                i("jquery")
            },
            "./src/widgets/ParameterContainer/index.js": function(e, s, i) {
                "use strict";

                function t() {
                    new Swiper("#parameter-swiper", {
                        grabCursor: !0,
                        pagination: {
                            el: ".swiper-pagination",
                            clickable: !0
                        },
                        autoplay: {
                            pauseOnMouseEnter: !1,
                            disableOnInteraction: !1,
                            delay: 3e3
                        }
                    })
                }
                i.d(s, {
                    parameterSwiper: function() {
                        return t
                    }
                })
            },
            "./src/widgets/SeriseContainer/index.js": function(e, s, i) {
                "use strict";
                var t = i("jquery");
                t((function() {
                    t("#sideBtn").on("click", (function() {
                        var e = t(t.CN(".serise-container"));
                        e.hasClass(t.CN("show")) ? e.addClass(t.CN("hide")).removeClass(t.CN("show")) : e.addClass(t.CN("show")).removeClass(t.CN("hide"))
                    })), t("#popup-tab").delegate(t.CN(".tabTitle"), "click", (function(e) {
                        t(this).addClass(t.CN("active")).siblings().removeClass(t.CN("active")), t(t.CN(".tabbody .tabCard")).eq(t(this).index()).show().siblings().hide(), t(t.CN(".pc .img")).eq(t(this).index()).addClass(t.CN("active")).siblings().removeClass(t.CN("active")), t(t.CN(".mob .img")).eq(t(this).index()).addClass(t.CN("active")).siblings().removeClass(t.CN("active"))
                    }))
                }))
            },
            "./src/widgets/basics.js": function(e, s, i) {
                "use strict";
                i.d(s, {
                    basics: function() {
                        return n
                    }
                });
                var t = i("jquery");

                function n() {
                    t(".ad-bar").length > 0 && t(t.CN(".container")).css({
                        "margin-top": "110px"
                    }), t("#product_subscription_b").on("click", (function() {
                        t("#subscribe-modal").css({
                            display: "block"
                        })
                    }))
                }
            },
            "./src/widgets/debug.js": function(e, s, i) {
                "use strict";
                i.d(s, {
                    debugfunction: function() {
                        return n
                    }
                });
                var t = i("jquery");

                function n() {
                    var e, s, i, n, c, o, a, r, g = null,
                        p = !1,
                        _ = null,
                        l = null,
                        m = null,
                        u = null;

                    function d() {
                        var e = window.innerWidth,
                            s = window.innerHeight,
                            i = window.outerWidth,
                            n = window.outerHeight;
                        g && (g.text("分辨率".concat(e, "*").concat(s, " & 窗口").concat(i, "*").concat(n)), window.innerWidth > 751 ? (t(_).css("display", "block"), t(l).css("display", "block"), t(m).css("display", "block"), t(u).css("display", "block")) : (t(_).css("display", "none"), t(l).css("display", "none"), t(m).css("display", "none"), t(u).css("display", "none")))
                    }
                    // e = window.location.href, s = new URL(e), i = s.hostname, n = s.searchParams.get("debugResolution"), !(c = /^((25[0-5]|2[0-4][0-9]|[0-1]?[0-9][0-9]?)\.){3}(25[0-5]|2[0-4][0-9]|[0-1]?[0-9][0-9]?)$/).test(i) && !/^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|(([0-9a-fA-F]{1,4}:){1,7}|:):(([0-9a-fA-F]{1,4}:){1,7}|:))$/.test(i) && "show" != n || (p || function() {
                    //     (g = t("<div>", {
                    //         id: "resolution-container",
                    //         style: "position:fixed;top:10px;left:10px;z-index:9999999;background-color:rgba(0,0,0,0.6);color:#fff;padding:5px 10px;box-shadow:0 0 10px rgba(0,0,0,0.1);",
                    //         text: "分辨率: 加载中..."
                    //     })).appendTo("body"), p = !0, _ = t("<div>", {
                    //         id: "resolution-choose-Title",
                    //         style: "position:fixed;top:10px;left:263px;z-index:9999999;color:#000;padding:5px 10px;",
                    //         text: " 分辨率大小按钮=>"
                    //     }), l = t("<a>", {
                    //         id: "resolution-choose1",
                    //         style: "position:fixed;top:10px;left:405px;z-index:9999999;background-color:rgba(0,0,0,0.6);color:#fff;padding:5px 10px;box-shadow:0 0 10px rgba(0,0,0,0.1);border-radius:20px;cursor: pointer;",
                    //         text: "1920*960"
                    //     }), m = t("<a>", {
                    //         id: "resolution-choose2",
                    //         style: "position:fixed;top:10px;left:500px;z-index:9999999;background-color:rgba(0,0,0,0.6);color:#fff;padding:5px 10px;box-shadow:0 0 10px rgba(0,0,0,0.1);border-radius:20px;cursor: pointer;",
                    //         text: "1536*754"
                    //     }), u = t("<a>", {
                    //         id: "resolution-choose3",
                    //         style: "position:fixed;top:10px;left:592px;z-index:9999999;background-color:rgba(0,0,0,0.6);color:#fff;padding:5px 10px;box-shadow:0 0 10px rgba(0,0,0,0.1);border-radius:20px;cursor: pointer;",
                    //         text: "1280*600"
                    //     }), _.appendTo("body"), l.appendTo("body"), m.appendTo("body"), u.appendTo("body");
                    //     var e = window.location.href;
                    //     l.on("click", (function() {
                    //         window.open(e, "_blank", "width=1920,height=961")
                    //     })), m.on("click", (function() {
                    //         window.open(e, "_blank", "width=1536,height=755")
                    //     })), u.on("click", (function() {
                    //         window.open(e, "_blank", "width=1280,height=601")
                    //     }))
                    // }(), d(), c.test(i)), t(window).resize((o = d, a = 200, r = 0, function() {
                    //     var e = (new Date).getTime();
                    //     e - r >= a && (r = e, o.apply(void 0, arguments))
                    // }))
                }
            },
            "./src/widgets/index.js": function(e, s, i) {
                "use strict";
                i("./src/widgets/ContrastContainer/index.js"), i("./src/widgets/FullScreenVideo/index.js"), i("./src/widgets/LeftNav/index.js"), i("./src/widgets/SeriseContainer/index.js"), i("./src/widgets/ClassExtension.js");
                var t = i("./src/widgets/Album/index.js"),
                    n = i("./src/widgets/AlbumCart/index.js"),
                    c = i("./src/widgets/ParameterContainer/index.js"),
                    o = i("./src/widgets/basics.js");
                (0, t.default)(), (0, n.default)(), (0, c.parameterSwiper)(), (0, o.basics)()
            },
            "./src/index.html": function(e, s, i) {
                "use strict";
                var t = i("./node_modules/html-loader/dist/runtime/getUrl.js"),
                    n = i.n(t),
                    c = new URL(i("./src/assets/imagesBlack/Section1_web_image1.png"), i.b),
                    o = new URL(i("./src/assets/imagesBlack/Section1_mob_image1.jpg"), i.b),
                    a = new URL(i("./src/assets/imagesBlack/Section2_web_image1.png"), i.b),
                    r = new URL(i("./src/assets/imagesBlack/Section2_mob_image1.png"), i.b),
                    g = new URL(i("./src/assets/imagesBlack/Section2_web_image2.png"), i.b),
                    p = new URL(i("./src/assets/imagesBlack/Section2_mob_image2.png"), i.b),
                    _ = new URL(i("./src/assets/imagesBlack/Section2_web_image3.png"), i.b),
                    l = new URL(i("./src/assets/imagesBlack/Section2_mob_image3.png"), i.b),
                    m = new URL(i("./src/assets/imagesBlack/Section2_web_image4.png"), i.b),
                    u = new URL(i("./src/assets/imagesBlack/Section2_mob_image4.png"), i.b),
                    d = new URL(i("./src/assets/imagesBlack/Section2_web_image5.png"), i.b),
                    f = new URL(i("./src/assets/imagesBlack/Section2_mob_image5.png"), i.b),
                    b = new URL(i("./src/assets/imagesBlack/Section2_web_image6.png"), i.b),
                    S = new URL(i("./src/assets/imagesBlack/Section2_mob_image6.png"), i.b),
                    w = new URL(i("./src/assets/imagesBlack/Section2_web_image7.png"), i.b),
                    v = new URL(i("./src/assets/imagesBlack/Section2_mob_image7.png"), i.b),
                    h = new URL(i("./src/assets/imagesBlack/Section3_web_image1.png"), i.b),
                    k = new URL(i("./src/assets/imagesBlack/Section10_icon1.png"), i.b),
                    x = new URL(i("./src/assets/imagesBlack/Section10_icon2.png"), i.b),
                    B = new URL(i("./src/assets/imagesBlack/Section10_icon3.png"), i.b),
                    C = new URL(i("./src/assets/imagesBlack/Section10_icon4.png"), i.b),
                    E = new URL(i("./src/assets/imagesBlack/Section10_icon5.png"), i.b),
                    y = new URL(i("./src/assets/imagesBlack/Section10_icon6.png"), i.b),
                    j = new URL(i("./src/assets/imagesBlack/Section10_web_image1.jpg"), i.b),
                    P = new URL(i("./src/assets/imagesBlack/Section10_mob_image1.jpg"), i.b),
                    R = new URL(i("./src/assets/imagesBlack/Section11_web_image1.png"), i.b),
                    Q = new URL(i("./src/assets/imagesBlack/Section11_web_image2.png"), i.b),
                    L = new URL(i("./src/assets/imagesBlack/Section12_web_image1.png"), i.b),
                    U = new URL(i("./src/assets/imagesBlack/Section12_web_image2.png"), i.b),
                    N = new URL(i("./src/assets/imagesBlack/Section13_web_image1.png"), i.b),
                    O = new URL(i("./src/assets/imagesBlack/Section13_sign1.png"), i.b),
                    T = new URL(i("./src/assets/imagesBlack/Section13_web_image2.png"), i.b),
                    A = new URL(i("./src/assets/imagesBlack/Section6_web_image1.png"), i.b),
                    q = new URL(i("./src/assets/imagesBlack/Section6_web_image2.png"), i.b),
                    W = new URL(i("./src/assets/imagesBlack/Section5_web_image1.png"), i.b),
                    I = new URL(i("./src/assets/imagesBlack/Section5_web_image2.png"), i.b),
                    D = new URL(i("./src/assets/imagesBlack/Section5_sign1.png"), i.b),
                    F = new URL(i("./src/assets/imagesBlack/Section5_sign2.png"), i.b),
                    M = new URL(i("./src/assets/imagesBlack/Section4_sign1.png"), i.b),
                    V = new URL(i("./src/assets/imagesBlack/Section4_sign2.png"), i.b),
                    z = new URL(i("./src/assets/imagesBlack/Section4_sign3.png"), i.b),
                    H = new URL(i("./src/assets/imagesBlack/Section4_web_image1.png"), i.b),
                    $ = new URL(i("./src/assets/imagesBlack/Section8_web_image1.png"), i.b),
                    J = new URL(i("./src/assets/imagesBlack/Section8_web_image4.png"), i.b),
                    Y = new URL(i("./src/assets/imagesBlack/Section8_web_image2.png"), i.b),
                    G = new URL(i("./src/assets/imagesBlack/Section8_web_image3.png"), i.b),
                    K = new URL(i("./src/assets/imagesBlack/Section9_sign1.png"), i.b),
                    X = new URL(i("./src/assets/imagesBlack/Section9_sign2.png"), i.b),
                    Z = new URL(i("./src/assets/imagesBlack/Section9_web_image1.jpg"), i.b),
                    ee = new URL(i("./src/assets/imagesBlack/Section9_mob_image1.jpg"), i.b),
                    se = new URL(i("./src/assets/imagesBlack/Section9_icon1.png"), i.b),
                    ie = new URL(i("./src/assets/imagesBlack/Section21_web_image1.png"), i.b),
                    te = new URL(i("./src/assets/imagesBlack/Section21_web_image2.png"), i.b),
                    ne = new URL(i("./src/assets/imagesBlack/Section14_web_image1.png"), i.b),
                    ce = new URL(i("./src/assets/imagesBlack/Section14_icon1.png"), i.b),
                    oe = new URL(i("./src/assets/imagesBlack/Section14_web_image2.png"), i.b),
                    ae = new URL(i("./src/assets/imagesBlack/Section14_icon2.png"), i.b),
                    re = new URL(i("./src/assets/imagesBlack/Section14_web_image3.png"), i.b),
                    ge = new URL(i("./src/assets/imagesBlack/Section14_icon3.png"), i.b),
                    pe = new URL(i("./src/assets/imagesBlack/Section14_web_image4.png"), i.b),
                    _e = new URL(i("./src/assets/imagesBlack/Section15_petsnaps.jpg"), i.b),
                    le = new URL(i("./src/assets/imagesBlack/Section15_phone.png"), i.b),
                    me = new URL(i("./src/assets/imagesBlack/Section15_mob_phone.png"), i.b),
                    ue = new URL(i("./src/assets/imagesBlack/Section15_phone_product.png"), i.b),
                    de = new URL(i("./src/assets/imagesBlack/Section15_watch.jpg"), i.b),
                    fe = new URL(i("./src/assets/imagesBlack/Section16_web_image1.png"), i.b),
                    be = new URL(i("./src/assets/imagesBlack/Section_compare_series.png"), i.b),
                    Se = new URL(i("./src/assets/imagesBlack/Section_compare_slim.png"), i.b),
                    we = new URL(i("./src/assets/imagesBlack/Section_compare_master.png"), i.b),
                    ve = new URL(i("./src/assets/imagesBlack/Section_compare_maxV.png"), i.b),
                    he = new URL(i("./src/assets/imagesBlack/Section_compare_pro.png"), i.b),
                    ke = new URL(i("./src/assets/imagesBlack/Section_compare_plus.png"), i.b),
                    xe = new URL(i("./src/assets/imagesBlack/Section_compare_l.png"), i.b),
                    Be = new URL(i("./src/assets/imagesBlack/Section_compare_s.png"), i.b),
                    Ce = new URL(i("./src/assets/imagesBlack/Section_compare_qrevo.png"), i.b),
                    Ee = new URL(i("./src/assets/imagesBlack/Section_compare_EdgeC.png"), i.b),
                    ye = new URL(i("./src/assets/imagesBlack/Section21_web_image1.jpg"), i.b),
                    je = new URL(i("./src/assets/imagesBlack/Section21_web_image2.jpg"), i.b),
                    Pe = new URL(i("./src/assets/imagesBlack/Section21_web_image3.jpg"), i.b),
                    Re = new URL(i("./src/assets/imagesBlack/Section21_web_image4.jpg"), i.b),
                    Qe = new URL(i("./src/assets/imagesBlack/Section21_web_image5.jpg"), i.b),
                    Le = new URL(i("./src/assets/imagesBlack/Section21_web_image6.jpg"), i.b),
                    Ue = new URL(i("./src/assets/imagesBlack/Section21_web_image7.jpg"), i.b),
                    Ne = new URL(i("./src/assets/imagesBlack/Section21_web_image8.jpg"), i.b),
                    Oe = new URL(i("./src/assets/imagesBlack/Section21_web_image9.jpg"), i.b),
                    Te = new URL(i("./src/assets/imagesBlack/Section21_web_image10.jpg"), i.b),
                    Ae = new URL(i("./src/assets/imagesBlack/Section21_web_image11.jpg"), i.b),
                    qe = new URL(i("./src/assets/imagesBlack/Section21_web_image12.jpg"), i.b);
                n()(c), n()(o), n()(a), n()(r), n()(g), n()(p), n()(_), n()(l), n()(m), n()(u), n()(d), n()(f), n()(b), n()(S), n()(w), n()(v), n()(h), n()(k), n()(x), n()(B), n()(C), n()(E), n()(y), n()(j), n()(P), n()(R), n()(Q), n()(L), n()(U), n()(N), n()(O), n()(T), n()(A), n()(q), n()(W), n()(I), n()(D), n()(F), n()(M), n()(V), n()(z), n()(H), n()($), n()(J), n()(Y), n()(G), n()(K), n()(X), n()(Z), n()(ee), n()(se), n()(ie), n()(te), n()(ne), n()(ce), n()(oe), n()(ae), n()(re), n()(ge), n()(pe), n()(_e), n()(le), n()(me), n()(ue), n()(de), n()(fe), n()(be), n()(Se), n()(we), n()(ve), n()(he), n()(ke), n()(xe), n()(Be), n()(Ce), n()(Ee), n()(ye), n()(je), n()(Pe), n()(Re), n()(Qe), n()(Le), n()(Ue), n()(Ne), n()(Oe), n()(Te), n()(Ae), n()(qe)
            },
            "./node_modules/html-loader/dist/runtime/getUrl.js": function(e) {
                "use strict";
                e.exports = function(e, s) {
                    return s || (s = {}), e ? (e = String(e.__esModule ? e.default : e), s.hash && (e += s.hash), s.maybeNeedQuotes && /[\t\n\f\r "'=<>`]/.test(e) ? '"'.concat(e, '"') : e) : e
                }
            },
            "./node_modules/split-type/dist/index.js": function(e, s, i) {
                "use strict";

                function t(e, s) {
                    return Object.getOwnPropertyNames(Object(e)).reduce((function(i, t) {
                        var n = Object.getOwnPropertyDescriptor(Object(e), t),
                            c = Object.getOwnPropertyDescriptor(Object(s), t);
                        return Object.defineProperty(i, t, c || n)
                    }), {})
                }! function() {
                    function e() {
                        for (var e = arguments.length, s = 0; s < e; s++) {
                            var i = s < 0 || arguments.length <= s ? void 0 : arguments[s];
                            1 === i.nodeType || 11 === i.nodeType ? this.appendChild(i) : this.appendChild(document.createTextNode(String(i)))
                        }
                    }

                    function s() {
                        for (; this.lastChild;) this.removeChild(this.lastChild);
                        arguments.length && this.append.apply(this, arguments)
                    }

                    function i() {
                        for (var e = this.parentNode, s = arguments.length, i = new Array(s), t = 0; t < s; t++) i[t] = arguments[t];
                        var n = i.length;
                        if (e)
                            for (n || e.removeChild(this); n--;) {
                                var c = i[n];
                                "object" != typeof c ? c = this.ownerDocument.createTextNode(c) : c.parentNode && c.parentNode.removeChild(c), n ? e.insertBefore(this.previousSibling, c) : e.replaceChild(c, this)
                            }
                    }
                    "undefined" != typeof Element && (Element.prototype.append || (Element.prototype.append = e, DocumentFragment.prototype.append = e), Element.prototype.replaceChildren || (Element.prototype.replaceChildren = s, DocumentFragment.prototype.replaceChildren = s), Element.prototype.replaceWith || (Element.prototype.replaceWith = i, DocumentFragment.prototype.replaceWith = i))
                }();
                Object.entries;
                var n = "\\ud800-\\udfff",
                    c = "\\u0300-\\u036f\\ufe20-\\ufe23",
                    o = "\\u20d0-\\u20f0",
                    a = "\\ufe0e\\ufe0f",
                    r = "[".concat(n, "]"),
                    g = "[".concat(c).concat(o, "]"),
                    p = "\\ud83c[\\udffb-\\udfff]",
                    _ = "(?:".concat(g, "|").concat(p, ")"),
                    l = "[^".concat(n, "]"),
                    m = "(?:\\ud83c[\\udde6-\\uddff]){2}",
                    u = "[\\ud800-\\udbff][\\udc00-\\udfff]",
                    d = "\\u200d",
                    f = "".concat(_, "?"),
                    b = "[".concat(a, "]?"),
                    S = b + f + ("(?:" + d + "(?:" + [l, m, u].join("|") + ")" + b + f + ")*"),
                    w = "(?:".concat(["".concat(l).concat(g, "?"), g, m, u, r].join("|"), "\n)");
                RegExp("".concat(p, "(?=").concat(p, ")|").concat(w).concat(S), "g"), RegExp("[".concat([d, n, c, o, a].join(""), "]"));
                var v = {
                    splitClass: "",
                    lineClass: "line",
                    wordClass: "word",
                    charClass: "char",
                    types: ["lines", "words", "chars"],
                    absolute: !1,
                    tagName: "div"
                };
                t(v, {})
            },
            "./src/assets/imagesBlack/Section10_icon1.png": function(e, s, i) {
                "use strict";
                e.exports = i.p + "files/qrevol_Section10_icon1.png"
            },
            "./src/assets/imagesBlack/Section10_icon2.png": function(e, s, i) {
                "use strict";
                e.exports = i.p + "files/qrevol_Section10_icon2.png"
            },
            "./src/assets/imagesBlack/Section10_icon3.png": function(e, s, i) {
                "use strict";
                e.exports = i.p + "files/qrevol_Section10_icon3.png"
            },
            "./src/assets/imagesBlack/Section10_icon4.png": function(e, s, i) {
                "use strict";
                e.exports = i.p + "files/qrevol_Section10_icon4.png"
            },
            "./src/assets/imagesBlack/Section10_icon5.png": function(e, s, i) {
                "use strict";
                e.exports = i.p + "files/qrevol_Section10_icon5.png"
            },
            "./src/assets/imagesBlack/Section10_icon6.png": function(e, s, i) {
                "use strict";
                e.exports = i.p + "files/qrevol_Section10_icon6.png"
            },
            "./src/assets/imagesBlack/Section10_mob_image1.jpg": function(e, s, i) {
                "use strict";
                e.exports = i.p + "files/qrevol_Section10_mob_image1.jpg"
            },
            "./src/assets/imagesBlack/Section10_web_image1.jpg": function(e, s, i) {
                "use strict";
                e.exports = i.p + "files/qrevol_Section10_web_image1.jpg"
            },
            "./src/assets/imagesBlack/Section11_web_image1.png": function(e, s, i) {
                "use strict";
                e.exports = i.p + "files/qrevol_Section11_web_image1.png"
            },
            "./src/assets/imagesBlack/Section11_web_image2.png": function(e, s, i) {
                "use strict";
                e.exports = i.p + "files/qrevol_Section11_web_image2.png"
            },
            "./src/assets/imagesBlack/Section12_web_image1.png": function(e, s, i) {
                "use strict";
                e.exports = i.p + "files/qrevol_Section12_web_image1.png"
            },
            "./src/assets/imagesBlack/Section12_web_image2.png": function(e, s, i) {
                "use strict";
                e.exports = i.p + "files/qrevol_Section12_web_image2.png"
            },
            "./src/assets/imagesBlack/Section13_sign1.png": function(e, s, i) {
                "use strict";
                e.exports = i.p + "files/qrevol_Section13_sign1.png"
            },
            "./src/assets/imagesBlack/Section13_web_image1.png": function(e, s, i) {
                "use strict";
                e.exports = i.p + "files/qrevol_Section13_web_image1.png"
            },
            "./src/assets/imagesBlack/Section13_web_image2.png": function(e, s, i) {
                "use strict";
                e.exports = i.p + "files/qrevol_Section13_web_image2.png"
            },
            "./src/assets/imagesBlack/Section14_icon1.png": function(e, s, i) {
                "use strict";
                e.exports = i.p + "files/qrevol_Section14_icon1.png"
            },
            "./src/assets/imagesBlack/Section14_icon2.png": function(e, s, i) {
                "use strict";
                e.exports = i.p + "files/qrevol_Section14_icon2.png"
            },
            "./src/assets/imagesBlack/Section14_icon3.png": function(e, s, i) {
                "use strict";
                e.exports = i.p + "files/qrevol_Section14_icon3.png"
            },
            "./src/assets/imagesBlack/Section14_web_image1.png": function(e, s, i) {
                "use strict";
                e.exports = i.p + "files/qrevol_Section14_web_image1.png"
            },
            "./src/assets/imagesBlack/Section14_web_image2.png": function(e, s, i) {
                "use strict";
                e.exports = i.p + "files/qrevol_Section14_web_image2.png"
            },
            "./src/assets/imagesBlack/Section14_web_image3.png": function(e, s, i) {
                "use strict";
                e.exports = i.p + "files/qrevol_Section14_web_image3.png"
            },
            "./src/assets/imagesBlack/Section14_web_image4.png": function(e, s, i) {
                "use strict";
                e.exports = i.p + "files/qrevol_Section14_web_image4.png"
            },
            "./src/assets/imagesBlack/Section15_mob_phone.png": function(e, s, i) {
                "use strict";
                e.exports = i.p + "files/qrevol_Section15_mob_phone.png"
            },
            "./src/assets/imagesBlack/Section15_petsnaps.jpg": function(e, s, i) {
                "use strict";
                e.exports = i.p + "files/qrevol_Section15_petsnaps.jpg"
            },
            "./src/assets/imagesBlack/Section15_phone.png": function(e, s, i) {
                "use strict";
                e.exports = i.p + "files/qrevol_Section15_phone.png"
            },
            "./src/assets/imagesBlack/Section15_phone_product.png": function(e, s, i) {
                "use strict";
                e.exports = i.p + "files/qrevol_Section15_phone_product.png"
            },
            "./src/assets/imagesBlack/Section15_watch.jpg": function(e, s, i) {
                "use strict";
                e.exports = i.p + "files/qrevol_Section15_watch.jpg"
            },
            "./src/assets/imagesBlack/Section16_web_image1.png": function(e, s, i) {
                "use strict";
                e.exports = i.p + "files/qrevol_Section16_web_image1.png"
            },
            "./src/assets/imagesBlack/Section1_mob_image1.jpg": function(e, s, i) {
                "use strict";
                e.exports = i.p + "files/qrevol_Section1_mob_image1.jpg"
            },
            "./src/assets/imagesBlack/Section1_web_image1.png": function(e, s, i) {
                "use strict";
                e.exports = i.p + "files/qrevol_Section1_web_image1.png"
            },
            "./src/assets/imagesBlack/Section21_web_image1.jpg": function(e, s, i) {
                "use strict";
                e.exports = i.p + "files/qrevol_Section21_web_image1.jpg"
            },
            "./src/assets/imagesBlack/Section21_web_image1.png": function(e, s, i) {
                "use strict";
                e.exports = i.p + "files/qrevol_Section21_web_image1.png"
            },
            "./src/assets/imagesBlack/Section21_web_image10.jpg": function(e, s, i) {
                "use strict";
                e.exports = i.p + "files/qrevol_Section21_web_image10.jpg"
            },
            "./src/assets/imagesBlack/Section21_web_image11.jpg": function(e, s, i) {
                "use strict";
                e.exports = i.p + "files/qrevol_Section21_web_image11.jpg"
            },
            "./src/assets/imagesBlack/Section21_web_image12.jpg": function(e, s, i) {
                "use strict";
                e.exports = i.p + "files/qrevol_Section21_web_image12.jpg"
            },
            "./src/assets/imagesBlack/Section21_web_image2.jpg": function(e, s, i) {
                "use strict";
                e.exports = i.p + "files/qrevol_Section21_web_image2.jpg"
            },
            "./src/assets/imagesBlack/Section21_web_image2.png": function(e, s, i) {
                "use strict";
                e.exports = i.p + "files/qrevol_Section21_web_image2.png"
            },
            "./src/assets/imagesBlack/Section21_web_image3.jpg": function(e, s, i) {
                "use strict";
                e.exports = i.p + "files/qrevol_Section21_web_image3.jpg"
            },
            "./src/assets/imagesBlack/Section21_web_image4.jpg": function(e, s, i) {
                "use strict";
                e.exports = i.p + "files/qrevol_Section21_web_image4.jpg"
            },
            "./src/assets/imagesBlack/Section21_web_image5.jpg": function(e, s, i) {
                "use strict";
                e.exports = i.p + "files/qrevol_Section21_web_image5.jpg"
            },
            "./src/assets/imagesBlack/Section21_web_image6.jpg": function(e, s, i) {
                "use strict";
                e.exports = i.p + "files/qrevol_Section21_web_image6.jpg"
            },
            "./src/assets/imagesBlack/Section21_web_image7.jpg": function(e, s, i) {
                "use strict";
                e.exports = i.p + "files/qrevol_Section21_web_image7.jpg"
            },
            "./src/assets/imagesBlack/Section21_web_image8.jpg": function(e, s, i) {
                "use strict";
                e.exports = i.p + "files/qrevol_Section21_web_image8.jpg"
            },
            "./src/assets/imagesBlack/Section21_web_image9.jpg": function(e, s, i) {
                "use strict";
                e.exports = i.p + "files/qrevol_Section21_web_image9.jpg"
            },
            "./src/assets/imagesBlack/Section2_mob_image1.png": function(e, s, i) {
                "use strict";
                e.exports = i.p + "files/qrevol_Section2_mob_image1.png"
            },
            "./src/assets/imagesBlack/Section2_mob_image2.png": function(e, s, i) {
                "use strict";
                e.exports = i.p + "files/qrevol_Section2_mob_image2.png"
            },
            "./src/assets/imagesBlack/Section2_mob_image3.png": function(e, s, i) {
                "use strict";
                e.exports = i.p + "files/qrevol_Section2_mob_image3.png"
            },
            "./src/assets/imagesBlack/Section2_mob_image4.png": function(e, s, i) {
                "use strict";
                e.exports = i.p + "files/qrevol_Section2_mob_image4.png"
            },
            "./src/assets/imagesBlack/Section2_mob_image5.png": function(e, s, i) {
                "use strict";
                e.exports = i.p + "files/qrevol_Section2_mob_image5.png"
            },
            "./src/assets/imagesBlack/Section2_mob_image6.png": function(e, s, i) {
                "use strict";
                e.exports = i.p + "files/qrevol_Section2_mob_image6.png"
            },
            "./src/assets/imagesBlack/Section2_mob_image7.png": function(e, s, i) {
                "use strict";
                e.exports = i.p + "files/qrevol_Section2_mob_image7.png"
            },
            "./src/assets/imagesBlack/Section2_web_image1.png": function(e, s, i) {
                "use strict";
                e.exports = i.p + "files/qrevol_Section2_web_image1.png"
            },
            "./src/assets/imagesBlack/Section2_web_image2.png": function(e, s, i) {
                "use strict";
                e.exports = i.p + "files/qrevol_Section2_web_image2.png"
            },
            "./src/assets/imagesBlack/Section2_web_image3.png": function(e, s, i) {
                "use strict";
                e.exports = i.p + "files/qrevol_Section2_web_image3.png"
            },
            "./src/assets/imagesBlack/Section2_web_image4.png": function(e, s, i) {
                "use strict";
                e.exports = i.p + "files/qrevol_Section2_web_image4.png"
            },
            "./src/assets/imagesBlack/Section2_web_image5.png": function(e, s, i) {
                "use strict";
                e.exports = i.p + "files/qrevol_Section2_web_image5.png"
            },
            "./src/assets/imagesBlack/Section2_web_image6.png": function(e, s, i) {
                "use strict";
                e.exports = i.p + "files/qrevol_Section2_web_image6.png"
            },
            "./src/assets/imagesBlack/Section2_web_image7.png": function(e, s, i) {
                "use strict";
                e.exports = i.p + "files/qrevol_Section2_web_image7.png"
            },
            "./src/assets/imagesBlack/Section3_web_image1.png": function(e, s, i) {
                "use strict";
                e.exports = i.p + "files/qrevol_Section3_web_image1.png"
            },
            "./src/assets/imagesBlack/Section4_sign1.png": function(e, s, i) {
                "use strict";
                e.exports = i.p + "files/qrevol_Section4_sign1.png"
            },
            "./src/assets/imagesBlack/Section4_sign2.png": function(e, s, i) {
                "use strict";
                e.exports = i.p + "files/qrevol_Section4_sign2.png"
            },
            "./src/assets/imagesBlack/Section4_sign3.png": function(e, s, i) {
                "use strict";
                e.exports = i.p + "files/qrevol_Section4_sign3.png"
            },
            "./src/assets/imagesBlack/Section4_web_image1.png": function(e, s, i) {
                "use strict";
                e.exports = i.p + "files/qrevol_Section4_web_image1.png"
            },
            "./src/assets/imagesBlack/Section5_sign1.png": function(e, s, i) {
                "use strict";
                e.exports = i.p + "files/qrevol_Section5_sign1.png"
            },
            "./src/assets/imagesBlack/Section5_sign2.png": function(e, s, i) {
                "use strict";
                e.exports = i.p + "files/qrevol_Section5_sign2.png"
            },
            "./src/assets/imagesBlack/Section5_web_image1.png": function(e, s, i) {
                "use strict";
                e.exports = i.p + "files/qrevol_Section5_web_image1.png"
            },
            "./src/assets/imagesBlack/Section5_web_image2.png": function(e, s, i) {
                "use strict";
                e.exports = i.p + "files/qrevol_Section5_web_image2.png"
            },
            "./src/assets/imagesBlack/Section6_web_image1.png": function(e, s, i) {
                "use strict";
                e.exports = i.p + "files/qrevol_Section6_web_image1.png"
            },
            "./src/assets/imagesBlack/Section6_web_image2.png": function(e, s, i) {
                "use strict";
                e.exports = i.p + "files/qrevol_Section6_web_image2.png"
            },
            "./src/assets/imagesBlack/Section8_web_image1.png": function(e, s, i) {
                "use strict";
                e.exports = i.p + "files/qrevol_Section8_web_image1.png"
            },
            "./src/assets/imagesBlack/Section8_web_image2.png": function(e, s, i) {
                "use strict";
                e.exports = i.p + "files/qrevol_Section8_web_image2.png"
            },
            "./src/assets/imagesBlack/Section8_web_image3.png": function(e, s, i) {
                "use strict";
                e.exports = i.p + "files/qrevol_Section8_web_image3.png"
            },
            "./src/assets/imagesBlack/Section8_web_image4.png": function(e, s, i) {
                "use strict";
                e.exports = i.p + "files/qrevol_Section8_web_image4.png"
            },
            "./src/assets/imagesBlack/Section9_icon1.png": function(e, s, i) {
                "use strict";
                e.exports = i.p + "files/qrevol_Section9_icon1.png"
            },
            "./src/assets/imagesBlack/Section9_mob_image1.jpg": function(e, s, i) {
                "use strict";
                e.exports = i.p + "files/qrevol_Section9_mob_image1.jpg"
            },
            "./src/assets/imagesBlack/Section9_sign1.png": function(e, s, i) {
                "use strict";
                e.exports = i.p + "files/qrevol_Section9_sign1.png"
            },
            "./src/assets/imagesBlack/Section9_sign2.png": function(e, s, i) {
                "use strict";
                e.exports = i.p + "files/qrevol_Section9_sign2.png"
            },
            "./src/assets/imagesBlack/Section9_web_image1.jpg": function(e, s, i) {
                "use strict";
                e.exports = i.p + "files/qrevol_Section9_web_image1.jpg"
            },
            "./src/assets/imagesBlack/Section_compare_EdgeC.png": function(e, s, i) {
                "use strict";
                e.exports = i.p + "files/qrevol_Section_compare_EdgeC.png"
            },
            "./src/assets/imagesBlack/Section_compare_l.png": function(e, s, i) {
                "use strict";
                e.exports = i.p + "files/qrevol_Section_compare_l.png"
            },
            "./src/assets/imagesBlack/Section_compare_master.png": function(e, s, i) {
                "use strict";
                e.exports = i.p + "files/qrevol_Section_compare_master.png"
            },
            "./src/assets/imagesBlack/Section_compare_maxV.png": function(e, s, i) {
                "use strict";
                e.exports = i.p + "files/qrevol_Section_compare_maxV.png"
            },
            "./src/assets/imagesBlack/Section_compare_plus.png": function(e, s, i) {
                "use strict";
                e.exports = i.p + "files/qrevol_Section_compare_plus.png"
            },
            "./src/assets/imagesBlack/Section_compare_pro.png": function(e, s, i) {
                "use strict";
                e.exports = i.p + "files/qrevol_Section_compare_pro.png"
            },
            "./src/assets/imagesBlack/Section_compare_qrevo.png": function(e, s, i) {
                "use strict";
                e.exports = i.p + "files/qrevol_Section_compare_qrevo.png"
            },
            "./src/assets/imagesBlack/Section_compare_s.png": function(e, s, i) {
                "use strict";
                e.exports = i.p + "files/qrevol_Section_compare_s.png"
            },
            "./src/assets/imagesBlack/Section_compare_series.png": function(e, s, i) {
                "use strict";
                e.exports = i.p + "files/qrevol_Section_compare_series.png"
            },
            "./src/assets/imagesBlack/Section_compare_slim.png": function(e, s, i) {
                "use strict";
                e.exports = i.p + "files/qrevol_Section_compare_slim.png"
            },
            jquery: function(e) {
                "use strict";
                e.exports = $
            }
        },
        s = {};

    function i(t) {
        var n = s[t];
        if (void 0 !== n) return n.exports;
        var c = s[t] = {
            exports: {}
        };
        return e[t](c, c.exports, i), c.exports
    }
    i.m = e, i.n = function(e) {
            var s = e && e.__esModule ? function() {
                return e.default
            } : function() {
                return e
            };
            return i.d(s, {
                a: s
            }), s
        }, i.d = function(e, s) {
            for (var t in s) i.o(s, t) && !i.o(e, t) && Object.defineProperty(e, t, {
                enumerable: !0,
                get: s[t]
            })
        }, i.o = function(e, s) {
            return Object.prototype.hasOwnProperty.call(e, s)
        }, i.p = "/cdn/shop/", i.b = document.baseURI || self.location.href,
        function() {
            "use strict";
            i("./src/index.html"), i("./src/widgets/index.js"), i("./src/js/main.js")
        }()
}();
